import React from "react";
import { Table } from "antd";

const GamesLeaderboard = (data) => {
  // ----------- Constants -----------
  const columns = [
    { title: "Game", dataIndex: "gameName", key: "gameName" },
    { title: "Rank", dataIndex: "rank", key: "rank" },
    {
      title: "Tournaments",
      dataIndex: "tournamentsPlayed",
      key: "tournamentsPlayed",
    },
    { title: "Trophies", dataIndex: "trophies", key: "trophies" },
  ];

  // --------------- Handlers -------------
  const handleGameId = (gameId) => {
    data.setGameId(gameId);
  };

  return (
    <div className="games-leaderboard glass-card">
      <div className="table-responsive">
        <Table
          columns={columns}
          dataSource={data.data}
          pagination={false}
          bordered={false}
          className="games-table"
          scroll={{ y: 200 }}
          onRow={(record) => ({
            onClick: () => handleGameId(record.gameId),
          })}
        />
      </div>
    </div>
  );
};

export default GamesLeaderboard;
